import React from 'react'
import Button from '../../button'
import FormInput from '../../form-input'
import { formValidation } from '../../../utils/functions'
import { useUpdateVoluntaryPension } from '../../../redux/employees/hook/salaries'
import { useParams } from 'react-router-dom'
import DOMPurify from 'dompurify'
import { useForm } from 'react-hook-form'
import { useGetEmployee } from '../../../redux/employees/hook'
import { store } from '../../../redux'
import { setAlert } from '../../../redux/components/components-slice'

const VoluntaryPension = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })
  const { id } = useParams()
  const { data: employee, isLoading: loadingEmployee } = useGetEmployee(id)

  const { mutateAsync: updateVoluntaryPension, isLoading } =
    useUpdateVoluntaryPension()

  const submitForm = async (data) => {
    const employee_voluntary_pension = DOMPurify.sanitize(
      data?.employee_voluntary_pension
    )
    const employer_voluntary_pension = DOMPurify.sanitize(
      data?.employer_voluntary_pension
    )
    let payload = {
      id,
      data: {
        employee_voluntary_pension,
        employer_voluntary_pension,
      },
    }
    await updateVoluntaryPension(payload).then(() => {
      store.dispatch(
        setAlert(true, 'success', 'Voluntary Pension Updated Successfully')
      )
    })
  }
  return (
    <form
      onSubmit={handleSubmit(submitForm)}
      className='flex flex-col gap-4 bg-white rounded px-3 pt-3 pb-8'
    >
      <div className='flex md:justify-start justify-center p3-bold header-4 md:w-[20%] w-full'>
        Voluntary Pension
      </div>{' '}
      <div className='flex flex-col md:flex-row gap-4 w-full'>
        <div className='w-full'>
          <FormInput
            placeholder={'Employee Pension'}
            label={'Employee Pension'}
            name='employee_voluntary_pension'
            type='text'
            readOnly={loadingEmployee}
            inputRef={register(formValidation('text', true))}
            error={errors.employee_voluntary_pension}
            defaultValue={employee?.salary?.employee_voluntary_pension}
            errorMessage={
              errors.employee_voluntary_pension &&
              errors.employee_voluntary_pension.message
            }
          />
        </div>
        <div className='w-full'>
          <FormInput
            label={'Employer Pension'}
            placeholder={'Employeer Pension'}
            name='employer_voluntary_pension'
            type='text'
            readOnly={loadingEmployee}
            inputRef={register(formValidation('text', true))}
            defaultValue={employee?.salary?.employer_voluntary_pension}
            error={errors.employer_voluntary_pension}
            errorMessage={
              errors.employer_voluntary_pension &&
              errors.employer_voluntary_pension.message
            }
          />
        </div>
      </div>
      <div className='flex items-end justify-end w-full'>
        <div className='w-[300px]'>
          <Button
            text='Update Voluntary Pension'
            type='submit'
            loading={isLoading}
            disabled={!employee}
          />
        </div>
      </div>
    </form>
  )
}

export default VoluntaryPension
